import React from 'react';

// Neutral "ROUTE N" pill. Same shape family as MainTag (design-handoff.md B.1).

const RouteBadge: React.FC<{ index: number }> = ({ index }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '2px 8px',
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 0.4,
      color: '#6c7872',
      background: '#f1f5f3',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    }}
  >
    Route {index}
  </span>
);

export default RouteBadge;
